import { useEffect, useRef } from '@wordpress/element';
import { useItem } from './hook';
import { contextConnect } from '../../context';
import { View } from '../../view';
import { useItemGroupContext } from '../context';
import { jsx as _jsx } from "react/jsx-runtime";
function UnconnectedItem(props, forwardedRef) {
  const {
    role,
    wrapperClassName,
    ...otherProps
  } = useItem(props);
  const itemRef = useRef(null);
  const {
    isList
  } = useItemGroupContext();
  useEffect(() => {
    if (isList && role === 'listitem' && !itemRef.current?.closest('ol, ul, menu, [role="list"], [role="directory"]')) {
      throw new Error('Item with list semantics must be rendered inside an element with role="list".');
    }
  }, [isList, role]);
  return /*#__PURE__*/_jsx("div", {
    ref: itemRef,
    role: role,
    className: wrapperClassName,
    children: /*#__PURE__*/_jsx(View, {
      ...otherProps,
      ref: forwardedRef
    })
  });
}

/**
 * `Item` is used in combination with `ItemGroup` to display a list of items
 * grouped and styled together.
 *
 * ```jsx
 * import {
 *   __experimentalItemGroup as ItemGroup,
 *   __experimentalItem as Item,
 * } from '@wordpress/components';
 *
 * function Example() {
 *   return (
 *     <ItemGroup>
 *       <Item>Code</Item>
 *       <Item>is</Item>
 *       <Item>Poetry</Item>
 *     </ItemGroup>
 *   );
 * }
 * ```
 */
export const Item = contextConnect(UnconnectedItem, 'Item');
export default Item;